<div class="navbar navbar-dark">
  <ul class="navbar-nav">
    <li class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="help-menu-dropdown" ngbDropdownToggle>
        <pcs-icon icon="pcs-icon-help_support" size="iconM"></pcs-icon>
        {{ 'navigation.help' | translate }}
      </a>
      <ul ngbDropdownMenu aria-labelledby="help-menu-dropdown">
        <li>
          <a (click)="mailToPcsSupport()" ngbDropdownItem>
            <pcs-icon icon="email" size="iconM"></pcs-icon>
            {{ 'navigation.support' | translate }}
          </a>
        </li>
        <li>
          <a (click)="goToPcsDocumentation()" ngbDropdownItem>
            <pcs-icon icon="library_books" size="iconM"></pcs-icon>
            {{ 'orangebook.help' | translate }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
